// 消費税率 (10%)。元は composables/order-entry.ts:20 に置いていたが、純粋な定数で
// utils/math.ts でしか使われていないため、Nuxt auto-import 経由ではなくこちらの
// module-local 定数に寄せて vitest からテスト可能にする。
// useMath() 等の export 名は不変なので呼び出し側の修正は不要。
export const TaxRate = 0.1

export const calculateSubtotalAmountByTotalAmount = (totalAmount: number) => {
  return Math.ceil(totalAmount / (TaxRate + 1))
}
export const calculateTaxAmountByTotalAmount = (totalAmount: number) => {
  return totalAmount - Math.ceil(totalAmount / (TaxRate + 1))
}

export const useMath = () => {
  return {
    calculateSubtotalAmountByTotalAmount,
    calculateTaxAmountByTotalAmount,
  }
}
